import { render, staticRenderFns } from "./clienthome.vue?vue&type=template&id=c47ee906&scoped=true"
import script from "./clienthome.vue?vue&type=script&lang=js"
export * from "./clienthome.vue?vue&type=script&lang=js"
import style0 from "./clienthome.vue?vue&type=style&index=0&id=c47ee906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47ee906",
  null
  
)

export default component.exports